import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ChipsFilter from '@components/commonFilters/ChipsFilter';

import { setFilters } from '@store/common/action';
import { getCommonFilters } from '@store/reducers';

import ApiClient from '@lib/apiClient';

import { printApiError } from '@utils/Util';

const FabricComposition = ({ type = 'FILTER', onSelectCallBack, isClearAll, onResetClearValue }) => {
	const [selectedItem, setSelectedItem] = useState([]);
	const [, setInputValue] = useState('');
	const [isUpdated, setIsUpdated] = useState(true);
	const [items, setItems] = useState([]);
	const [totalPercentage, setTotalPercentage] = useState(0);

	const onTotalPercentage = (slt) => {
		let sum = slt?.reduce((acc, item) => acc + item.percentage, 0);
		setTotalPercentage(sum);
	};

	const dispatch = useDispatch();
	const commonfilters = useSelector(getCommonFilters);

	useEffect(() => {
		if (isClearAll) {
			setSelectedItem([]);
			setIsUpdated(false);
			setTimeout(() => {
				setIsUpdated(true);
			}, 0);
		}
	}, [isClearAll]);

	const onGetgFabricSubCategory = async (searchTerm = '') => {
		return await ApiClient.GET(
			'getFabricCompositions',
			`?pageSize=20&search=${searchTerm.replace('%', '')}`
		)
			.then(({ data }) => {
				if (data) {
					let results = data?.data?.map((item) => {
						if (parseInt(item.percentage) + totalPercentage > 100) {
							return {
								value: item.id,
								label: `${item.percentage}% ${item.fiberName}`,
								percentage: item.percentage,
								isDisable: true
							};
						} else {
							return {
								value: item.id,
								label: `${item.percentage}% ${item.fiberName}`,
								percentage: item.percentage,
								isDisable: false
							};
						}
					});

					setItems(results);
					return results;
				}
			})
			.catch((error) => {
				printApiError(error);
			});
	};

	useEffect(() => {
		onGetgFabricSubCategory();
	}, []);

	const onSelectFabric = (value) => {
		setSelectedItem(value);
		let items = value.map((item) => item.value);
		if (type === 'FILTER') {
			onResetClearValue(false);
			dispatch(
				setFilters({
					...commonfilters,
					fabricCompositionPartIdList: items
				})
			);
		} else {
			onSelectCallBack(items);
		}
	};

	const loadOptions = async (inputValue) => {
		let response = await onGetgFabricSubCategory(inputValue);
		return response;
	};
	const handleInputChange = (value) => {
		setInputValue(value);
	};

	return (
		<div>
			{isUpdated && (
				<ChipsFilter
					type={'ASYNC'}
					allItems={items}
					title={'Composition'}
					onSetSelectedItem={(value) => onSelectFabric(value)}
					loadOptions={loadOptions}
					handleInputChange={handleInputChange}
					selectedValue={selectedItem}
					onTotalPercentage={onTotalPercentage}
				/>
			)}
		</div>
	);
};

export default FabricComposition;
